import $ from 'jquery'
import swal from 'sweetalert2'

const domainRegex = /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i
const { ignoredDomains } = window.APP.context.outbound_link_warning
const warningMessage = window.APP.context.outbound_link_warning.message

function getUrlDomain(url) {
  if (domainRegex.exec(url)) {
    return domainRegex.exec(url)[1].toLowerCase().replace('www.', '')
  }
  return ''
}

function shouldInterceptClick(url) {
  if (!url) {
    return false
  }

  const urlDomain = getUrlDomain(url)

  if (!urlDomain) {
    return false
  }

  if (ignoredDomains.indexOf(urlDomain) !== -1) {
    return false
  }

  return urlDomain !== getUrlDomain(window.location.href)
}

function warnOnOutboundLinks() {
  $(document).on('click', 'a', (ev) => {
    const url = $(ev.currentTarget).attr('href')

    if (!shouldInterceptClick(url)) {
      return true
    }

    ev.preventDefault()

    // SweetAlert2 does not support IE10.
    if (navigator.userAgent.indexOf('MSIE 10.0') !== -1) {
      if (window.confirm(warningMessage)) {
        window.location = url
      }
    } else {
      swal({
        text: warningMessage,
        width: '24em',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#cacaca',
        confirmButtonText: 'Continue',
      }).then((result) => {
        if ('value' in result && result.value) {
          window.location = url
        }
      })
    }
  })
}

export { warnOnOutboundLinks }
